module.exports = __webpack_public_path__ + "static/media/book-chaos.d6dcb6fb.jpg";